import gql from 'graphql-tag';
import HelperGraphql from 'utils/helper-graphql'
import FieldsChart from 'graphql/fields/FieldsChart'
import VariablesChart from 'graphql/variables/VariablesChart'

const fields = {
	...VariablesChart,
};

export default gql(`
	query chart_checkin_time( ${ HelperGraphql.createFields( fields ) } ) {
		chart_checkin_time( ${ HelperGraphql.createVariables( fields ) } ) {
	        ${FieldsChart}
	    }
	}
`);

